import usePrivateAxios from '@/common/api/usePrivateAxios';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { MaintenanceForwardingData, MaintenanceForwardingResponse } from '../types/maintenanceForwarding.type';

type UseMaintenanceForwarding = (forwardingId: string | undefined) => UseQueryResult<MaintenanceForwardingData, unknown>;

export const useMaintenanceForwarding: UseMaintenanceForwarding = (forwardingId) => {
  const privateAxios = usePrivateAxios();

  return useQuery<MaintenanceForwardingResponse, unknown, MaintenanceForwardingData>({
    enabled: !!forwardingId,
    queryKey: ['maintenanceForwarding', forwardingId],
    queryFn: () => privateAxios.get(`/maintenance/forwardings/${forwardingId}`),
    select: (data) => data?.data?.data,
  });
}
